import { render, staticRenderFns } from "./learn10.vue?vue&type=template&id=22deb5b7&scoped=true"
import script from "./learn10.vue?vue&type=script&lang=js"
export * from "./learn10.vue?vue&type=script&lang=js"
import style0 from "./learn10.vue?vue&type=style&index=0&id=22deb5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22deb5b7",
  null
  
)

export default component.exports